import { useNavigationContext } from 'application/contexts/NavigationContext';
import { usePageContext } from 'application/contexts/PageContext';
import { useEffect, useState } from 'react';
import { NavigationLeft } from 'ui/components';

export const NavigationLeftFeature: React.FC<Navigation.NavigationItem> = () => {
	const [grandparentNavItem, setGrandparentNavItem] = useState<Navigation.NavigationItem>({});
	const [currentPageNavItem, setCurrentPageNavItem] = useState<Navigation.NavigationItem>({});
	const [parentNavItem, setParentNavItem] = useState<Navigation.NavigationItem>({});
	const navContext = useNavigationContext();
	const pageContext = usePageContext();
	const navigationItemsData = navContext?.getNavigation({
		currentUrl: pageContext.url,
		includeHidden: true,
		includeRootItem: true
	});

	const getCurrentNavItems = (
		navItems: Navigation.NavigationItem[],
		path: Navigation.NavigationItem[] = []
	) => {
		navItems?.forEach((item) => {
			if (item.active) {
				if (item.current) {
					setCurrentPageNavItem(item);
					if (path.length > 0) {

						setParentNavItem(path[0]);
					}
					if (path.length > 1) {
						setGrandparentNavItem(path[1]);
					}
					else {
						// Set grandparent to the same as the parent, if there is no grandparent. This will display only parents and neighbors on small sites.
						setGrandparentNavItem(path[0]);
					}
				} else {
					// Add current item to the path and continue
					getCurrentNavItems(item.descendants, [item, ...path]);
				}
			}
		});
	};

	useEffect(() => {
		getCurrentNavItems(navigationItemsData);
	}, [pageContext.url]);

	if (!grandparentNavItem) return null;
	return <NavigationLeft headingNavItem={grandparentNavItem} parentNavItem={parentNavItem} currentNavItem={currentPageNavItem} />;
};
